import { Convention } from '../../../concepts/objects';
import { Physical } from './Physical';

export interface Snappable extends Physical {

    readonly shouldSnap: boolean;
}

export const Snappable = new Convention<Snappable>('Snappable');
